import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  standalone: true,
  imports: [CommonModule, DatePipe, MatTooltipModule],
  selector: 'table-next-task-renderer',
  template: `
    <div *ngIf="parsedTask">
      <div class="task-title" [matTooltip]="parsedTask.title" matTooltipShowDelay="500">
        {{ parsedTask.title }}
      </div>
    </div>
  `,
  styles: [
    `
      .task-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      }
    `,
  ],
})
export class TableNextTaskRendererComponent implements ICellRendererAngularComp {
  parsedTask: any;

  agInit(params: ICellRendererParams): void {
    try {
      if (params.value) {
        this.parsedTask = JSON.parse(params.value);
      }
    } catch (e) {
      console.error('Error parsing next_task JSON:', e);
    }
  }

  refresh(params: ICellRendererParams): boolean {
    try {
      if (typeof params.value === 'string') {
        try {
          this.parsedTask = JSON.parse(params.value);
        } catch (e) {
          this.parsedTask = null;
        }
      } else if (params.value) {
        this.parsedTask = params.value;
      } else {
        this.parsedTask = null;
      }
    } catch (e) {
      console.error('Error parsing next_task JSON:', e);
      this.parsedTask = null;
    }
    return true;
  }
}
